module.exports = "/src/views/games/other/images/action/unknown.png";